var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnTripLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10247_71225)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10247_71225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9143 12.7598L20.7034 12.7598L13.3359 21.5747L8.66927 21.5747C8.05043 21.5747 7.45694 21.8068 7.01936 22.2201C6.58177 22.6334 6.33594 23.1939 6.33594 23.7784C6.33594 24.3628 6.58177 24.9233 7.01935 25.3366C7.45694 25.7499 8.05043 25.9821 8.66927 25.9821L13.4584 25.9821L20.8259 34.7969L22.9131 34.7969L19.6348 25.9821L25.0026 25.9821L27.3359 29.2876L29.6693 29.2876L27.3359 23.7784L29.6693 18.2691L27.3359 18.2691L25.0026 21.5747L19.5368 21.5747L22.9143 12.7598Z",
    fill: "#FFFFFE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10247_71225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7537 33.037L8.96453 33.037L16.332 24.2222L20.9987 24.2222C21.6175 24.2222 22.211 23.99 22.6486 23.5768C23.0862 23.1635 23.332 22.603 23.332 22.0185C23.332 21.4341 23.0862 20.8735 22.6486 20.4603C22.211 20.047 21.6175 19.8148 20.9987 19.8148L16.2095 19.8148L8.84203 11L6.75487 11L10.0332 19.8148L4.66536 19.8148L2.33203 16.5093L-0.00130105 16.5093L2.33203 22.0185L-0.00130153 27.5278L2.33203 27.5278L4.66536 24.2222L10.1312 24.2222L6.7537 33.037Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10247_71225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 28,
    fill: "white",
    transform: "translate(4 37) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10247_71225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.037,
    height: 23.3333,
    fill: "white",
    transform: "translate(6.33594 34.7969) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10247_71225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.037,
    height: 23.3333,
    fill: "white",
    transform: "translate(0 22.0352) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnTripLight);
export default __webpack_public_path__ + "static/media/return-trip-light.a70751be0ddf75fdda0875457a6c5e6a.svg";
export { ForwardRef as ReactComponent };